// dependencies.
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom'
import { doc, getDoc } from 'firebase/firestore'
// components.
import { Body } from '../../components/Typography'
import { ScreenWrapper, Topbar, Wrapper } from '../../components/Layout'
// utils.
import { auth, db } from '../../js/firebase/firebase'
import { selectUserData } from '../../js/auth/authSelectors'
import { setCurrentUserData } from '../../js/auth/authSlice'
import { useAppDispatch, useAppSelector } from '../../js/store/hooks'

const StyledBody = styled(Body)({
  margin: 'auto',
  maxWidth: 360,
  padding: 16,
  textAlign: 'center',
})

const getHomePathForAccess = (access, cardId) => {
  if (access === 'superadmin' || access === 'admin' || access === 'developer') {
    return `/admin?cardId=${cardId}`
  }
  if (access === 'operator') {
    return `/funcionario?cardId=${cardId}`
  }
  return null
}

const CardDestinationScreen = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const params = useParams()
  const userData = useAppSelector(selectUserData)
  const cardId = params.cardId || ''
  const [statusMessage, setStatusMessage] = useState('Redirigiendo...')

  useEffect(() => {
    if (!cardId) {
      navigate('/')
      return undefined
    }

    const signInRedirect = `/signin?redirect=${encodeURIComponent(`/redirect-card/${cardId}`)}`
    let cancelled = false

    const goHome = (access) => {
      const path = getHomePathForAccess(access, cardId)
      if (!path) return false
      navigate(path)
      return true
    }

    if (goHome(userData?.access)) return undefined

    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (cancelled) return

      if (goHome(userData?.access)) return

      if (!user) {
        navigate(signInRedirect)
        return
      }

      // Firebase session exists but Redux/cookie access is missing — hydrate from Firestore.
      try {
        setStatusMessage('Redirigiendo...')
        const docSnap = await getDoc(doc(db, 'users', user.uid))
        if (cancelled) return

        if (!docSnap.exists()) {
          navigate(signInRedirect)
          return
        }

        const loadedUserData = docSnap.data()
        dispatch(setCurrentUserData({ user, userData: loadedUserData }))

        if (!goHome(loadedUserData?.access)) {
          navigate('/')
        }
      } catch (error) {
        console.error('Error resolving card destination:', error)
        if (!cancelled) {
          setStatusMessage('No se pudo abrir la tarjeta. Intente iniciar sesión nuevamente.')
          navigate(signInRedirect)
        }
      }
    })

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [cardId, dispatch, navigate, userData?.access])

  return (
    <ScreenWrapper>
      <Topbar label="CCU" />
      <Wrapper background="white">
        <StyledBody color="grey">{statusMessage}</StyledBody>
      </Wrapper>
    </ScreenWrapper>
  )
}

export default CardDestinationScreen
